import React from 'react';
import {FooterSection, Text} from './style.js';

const Footer = () =>{

    return(
        <FooterSection>
            <Text> copyright &copy; 2018 by ultra profile </Text>
        </FooterSection>
        
    )
}
export default Footer;